export const TARS_AND_OUTAGES_PATH = 'tars-and-outages';
export const MAINTANENCE_PATH = 'maintenance';
export const EXECUTE_CERTIFICATES_PATH_PREFIX = `/${MAINTANENCE_PATH}/certificates/execute`;
export const MOBILE_MAX_WIDTH = 768;
export const TABLET_MAX_WIDTH = 1024;

export const geCertificateExecutionPath = ({
  asset,
  certificateId,
}: {
  asset: string;
  certificateId: number;
}) => {
  return `${EXECUTE_CERTIFICATES_PATH_PREFIX}/${certificateId}?asset=${asset}`;
};
